module.exports = __webpack_public_path__ + "img/hotel-2a.613f1e08.jpg";